export interface Job {
  accountId: number
  jobId: number
  reconDate: string
  userId: number
  userName: string
  numCommands: number
  lastUpdated: string | Date
  status: JobStatus
  notes: string[]
  fatalErrors: number
  nonFatalErrors: number
  runEtls: boolean
  priority: number
  weight: number
  duration: number
  availableActions: JobAction[]
  isCustodyRun: boolean
}

export type JobAction = 'CANCEL' | 'RESUBMIT'

export interface Command {
  timestamp?: string
  type: string
  userName: string
  data: JobData
  note?: string
  jobId?: number
}

export interface Exception {
  exception?: string
}

export interface Status {
  ts: string
  status: JobStatus
  server?: string
  duration?: number // ms
}

export enum JobStatus {
  READY = 'READY',
  AWAITING_ACKNOWLEDGEMNET = 'AWAITING_ACKNOWLEDGEMNET', // it is misspelled in perseus controller https://stash.arbfund.com/projects/BIT/repos/perseus-controller/browse/perseus-data-model/src/main/java/com/ca/perseus/datamodel/job/JobStatus.java#11
  RUNNING = 'RUNNING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
  INDETERMINATE = 'INDETERMINATE',
  INVALID = 'INVALID',
}

export type JobData = {
  transactionIds: string[]
  transactionTypeLabel: TransactionTypeLabel
  accountIds: string[]
  userId: string
  id: string
}

export type TransactionTypeLabel = {
  id: string
  label: string
}

export interface JobRequest {
  startDate: string
  endDate: string
  accountIds: number[]
  dateType?: string
}

export interface JobActionResponseMessage {
  [errorDescription: string]: number[]
}

export interface JobCancelResponse {
  allSuccessful: boolean
  jobIdsUnableToCancel: JobActionResponseMessage
}

export interface JobResubmitResponse {
  allSuccessful: boolean
  jobIdsUnableToResubmit: JobActionResponseMessage
}
